import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions'
import { auth} from '../../../services';

export const GET_POSITIONS = 'GET_POSITIONS';
export const GET_POSITION_GROUPS = 'GET_POSITION_GROUPS';
export const ADD_POSITION = 'ADD_POSITION';
export const DELETE_POSITION = 'DELETE_POSITION';
export const UPDATE_POSITION = 'UPDATE_POSITION';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchPositions() {
	return function(dispatch) {
		dispatch(loader(true));

		var url = `${ROOT_API_URL}/ManagePosition/GetPositions`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios.get(url, options).then(function(response) {
				dispatch({
					type: GET_POSITIONS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function fetchPositionGroups() {
	return function(dispatch) {
		dispatch(loader(true));

		var url = `${ROOT_API_URL}/ManagePosition/GetPositionGroups`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios.get(url, options).then(function(response) {
				dispatch({
					type: GET_POSITION_GROUPS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function addPosition(model) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManagePosition/CreatePosition`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url,model)
			 .then(function(response) {
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: ADD_POSITION,
						payload: response.data.positions,
					});
					var success = response && response.data ? response.data.message : "Position Created Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Position Already Exists"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function deletePosition(position) {

	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManagePosition/DeletePosition`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url,position, options)
			.then((response) =>
			{
			if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: DELETE_POSITION,
					payload: response.data.positions
					});	
					var success = response && response.data ? response.data.message : "Position Deleted Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function updatePosition(model) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManagePosition/UpdatePosition`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url,model, options)
			.then((response) => {
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: UPDATE_POSITION,
						payload: response.data.positions
					});	
					var success = response && response.data ? response.data.message : "Position Updated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}
